import React from "react";
import {BrowserRouter, Redirect, Route, Switch} from "react-router-dom";
import {connect} from 'react-redux'
import Index from './pages/layout/index'
import Dashboard from './pages/dashboard/index'
import CloudIndex from './pages/cloud/layout/index'
import Components from './pages/common/doc'
import {FetchUtil} from "./pages/public/fetch_util";
import {URL_LOGIN_STATUS, URL_UEDITOEUPLOAD} from "./pages/public/variables";
import Util from "./pages/public/utils";
import Utils from "./pages/public/utils";
import {DragDropContext} from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'
import loadable from "./pages/loadable";
import OrderRoute from "./pages/mine/order";
import SubAccount from "./pages/mine/subAccount"
import UserAgreement from "./pages/userAgreement";
import ImChat from './pages/im/chat';
import SubscribeRoute from "./pages/mine/subscribe";
import './pages/config/globalVariable'
import CorpApi from "./pages/public/corp_api";
import Store from "./pages/store";
import noPermissions from "./pages/config/noPermissions/noPermissions";

const Signflow = loadable(() => import('./pages/signflow/signFlow'));

const Env = process.env.REACT_APP_ENV;


class App extends React.Component {

    constructor(props) {
        super(props);
        this.setLogin = this.setLogin.bind(this);
        this.state = {
            login: false,
        }
    }

    componentWillMount() {
        let url = window.location.href;
        if (url.indexOf("/index") > 0) {
            this.initScrmTitle()
        } else if (url.indexOf("/cloud") > 0) {
            this.initCloudTitle();
        } else if (url.indexOf('/im') > 0) {
            this.initCloudTitle('在线聊天-企微助手Pro');
        }
    }

    componentDidMount() {
        let url = window.location.href;
        if (url.indexOf("/index") > 0) {
            this.setLogin(true);
            this.getAccountData();
        } else if (url.indexOf("/dashboard") > 0) {
            this.setLogin(true);
            this.getAccountData();
        } else if (url.indexOf("/cloud") > 0) {
            this.setLogin(true);
            this.getAccountData();
        } else if (url.indexOf("/im") > 0) {
            this.setLogin(true);
            this.getAccountData();
        } else if (url.indexOf("/login") > 0) {
            this.setLogin(true);
        } else if (url.indexOf("/userAgreement") > 0) {
            this.setLogin(true);
        } else if (url.indexOf("/order") > 0) {
            this.setLogin(true);
            this.getAccountData();
        } else if (url.indexOf("/subscribe") > 0) {
            this.setLogin(true);
            this.getAccountData();
        } else if (url.indexOf("/register") > 0) {
            this.setLogin(true);
        } else if (url.indexOf("/findPass") > 0) {
            this.setLogin(true);
        } else if (url.indexOf("/components") > 0) {
            this.setLogin(true);
            this.getAccountData();
        } else if (url.indexOf("/subAccount") > 0) {
            this.setLogin(true);
            this.getAccountData();
        } else {
            this.checkLoginStatus();
        }

        let UE = window.UE;
        UE.Editor.prototype._bkGetActionUrl = UE.Editor.prototype.getActionUrl;
        UE.Editor.prototype.getActionUrl = function (action) {
            if (action == 'uploadimage' || action == 'uploadscrawl' || action == 'uploadimage') {
                return URL_UEDITOEUPLOAD;//此处写自定义的图片上传路径
            } else {
                return this._bkGetActionUrl.call(this, action);
            }
        };
        $('body').on('mouseenter', '.ant-select-dropdown,.ant-cascader-menus', function () {
            Util.disableScroll();
        });
        $('body').on('mousemove', '.ant-select-dropdown,.ant-cascader-menus', function () {
            Util.disableScroll();
        });
        $('body').on('mouseleave', '.ant-select-dropdown,.ant-cascader-menus', function () {
            Util.enableScroll();
        })
    }

    setLogin(login) {
        this.setState({
            login: login
        })
    }

    //获取用户信息
    getAccountData = () => {
        CorpApi.getUserOpenId((data) => {
            this.props.subAction(data)
            Store.setUserInfo(data);
        })
    }

    toHome() {
        window.location.replace('home.html');
        // window.location.replace(Path.getUserLogin());
    }

    checkLoginStatus() {
        let fetchUtil = new FetchUtil();
        let setLogin = this.setLogin;
        let pathToHome = this.toHome;
        fetchUtil.init()
            .setUrl(URL_LOGIN_STATUS)
            .setMethod('GET')
            .setOvertime(5000)
            .setCookieCors()
            .dofetch()
            .then((msg) => {
                let respMsg = msg.respMsg;
                if (msg.respCode == 0 && respMsg.loginStatus == 'ok') {
                    //登陆成功
                    setLogin(true);
                } else {
                    pathToHome();
                }
            })
            .catch(() => {
                pathToHome();
            });
    }

    initScrmTitle(title) {
        // Util.changeFavicon('/favicon.ico');
        // document.title = title ? title : '紫鲲_助力企业数字化转型_客户数字化运营与精准营销工具_企业微信SCRM';
    }

    initCloudTitle(title) {
        // Util.changeFavicon('/favicon_cloud.ico');
        // document.title = title ? title : '紫鲲_助力企业数字化转型_客户数字化运营与精准营销工具';
    }

    render() {
        return (
            this.state.login ?
                <BrowserRouter>
                    <Switch>
                        <Route path="/login" render={(props) => {
                            props.type = 'login';
                            props.subAction = this.props.subAction
                            return <Signflow {...props}/>
                        }}/>
                        <Route path="/register" render={(props) => {
                            props.type = 'register';
                            return <Signflow {...props}/>
                        }}/>
                        <Route path="/findPass" render={(props) => {
                            props.type = 'findPass';
                            return <Signflow {...props}/>
                        }}/>
                        <Route path="/index" component={Index}/>
                        <Route path="/dashboard" component={Dashboard}/>
                        <Route path="/cloud" component={CloudIndex}/>
                        <Route path="/userAgreement" component={UserAgreement}/>
                        {
                            this.props.subInfo.isSub == 0 ?
                                <Route path={"/im/chat"} component={ImChat}/> :
                                this.props.subInfo.isSub == 1 ?
                                    <Route path={"/im/chat"}
                                           component={Utils.wxWorkHelperProJurisdiction(this.props.subInfo.permissionConf, 'account', 'account_chat') ?
                                               ImChat : noPermissions}/> : <></>
                        }
                        {
                            Env == 'dev' ? <Route path="/components" component={Components}/> : ''
                        }
                        <Route path={'/order'}
                               component={this.props.subInfo.isSub == 0 ? OrderRoute : noPermissions}/>
                        <Route path={'/subAccount'} component={SubAccount}/>
                        <Route path={'/subscribe'} component={SubscribeRoute}/>
                        <Route exact path="/" render={() => (<Redirect to="/dashboard"/>)}></Route>
                    </Switch>
                </BrowserRouter> : ""
        );
    }
}

export default connect(
    state => {
        const {subReducer} = state
        return {
            subInfo: subReducer
        }
    },
    dispatch => {
        return {
            subAction: data => dispatch({type: 'zk_sub_info', data: data}),
        }
    }
)(DragDropContext(HTML5Backend)(App))